<section class="configure-notes-container">
    <form>
        <header>
            <h2>Configure Text Message</h2>
        </header>

        <main>
            <div class="row">
                <div>
                    <cc-single-select-dropdown
                        [label]="'Button Label'"
                        [size]="'fit-to-parent'"
                        [options]="buttonLabelOptions"
                        [(selected)]="buttonLabel"
                    >
                    </cc-single-select-dropdown>
                </div>
                <div>
                    <cc-text-input
                        [label]="'Title'"
                        [size]="'fit-to-parent'"
                        [disallowSpecialCharacters]="true"
                        [(value)]="title"
                    >
                    </cc-text-input>
                </div>
            </div>
            <div class="row">
                <cc-textarea
                    [label]="'Message'"
                    [size]="'fit-to-parent'"
                    [rows]="15"
                    [(value)]="message"
                >
                </cc-textarea>
            </div>
        </main>

        <footer>
            @if (isEditingExistingNote) {
                <cc-button
                    class="delete-button"
                    [type]="'naked'"
                    [icon]="{ name: 'close-circle', size: 'medium'} "
                    [colors]="{ color: 'var(--delete-note)', hoverColor: 'var(--delete-note)' }"
                    (pressed)="onDelete()"
                >
                    Delete Note
                </cc-button>
            }
            <div class="spacer"></div>
            <cc-button class="cancel-button" [type]="'naked'" (pressed)="onCancel()">Cancel</cc-button>
            <cc-button class="save-button" [type]="'solid'" [disabled]="!buttonLabel || !title || !message" (pressed)="onSave()">Save</cc-button>
        </footer>
    </form>
</section>
